<template>
  <div ref="pdf" class="pdf-container"></div>
</template>

<script>
import {
  STATUTE_URL,
  PRIVACY_POLICY_URL,
  TOKUSYO_URL,
} from "@/utils/constants";
import * as pdfJs from "pdfjs-dist/webpack.mjs";

export default {
  name: "pdf-view",
  data() {
    return {
      keepLoading: true,
    };
  },
  computed: {
    pdfUrl() {
      return this.$route.name === "terms"
        ? STATUTE_URL
        : this.$route.name === "privacy"
        ? PRIVACY_POLICY_URL
        : TOKUSYO_URL;
    },
  },
  mounted() {
    this.loadPdf();

    window.addEventListener("resize", this.resizeDebounce);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeDebounce);
  },
  methods: {
    resizeDebounce(delay = 200) {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.renderPdf(this._pdf);
      }, delay);
    },
    loadPdf() {
      const loadingTask = pdfJs.getDocument(this.pdfUrl);
      loadingTask.promise
        .then((pdf) => {
          this._pdf = pdf;
          this.renderPdf(pdf);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    renderPdf(pdf) {
      this._offsetWidth = this.$refs["pdf"]?.offsetWidth;
      for (let i = 1; i <= pdf.numPages; i++) {
        pdf.getPage(i).then((page) => {
          this.renderPdfPage(page, i);
        });
      }
    },
    renderPdfPage(page, i) {
      if (!this._offsetWidth) return;
      const canvasContainer = this.$refs["pdf"];
      const scale = this._offsetWidth / page.view[2];
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const dpr = window.devicePixelRatio || 1;
      const bsr =
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      const ratio = dpr / bsr;

      canvas.width = viewport.width * ratio;
      canvas.height = viewport.height * ratio;
      canvas.style.width = viewport.width + "px";
      canvas.style.height = viewport.height + "px";

      const renderContext = {
        canvasContext: context,
        transform: [ratio, 0, 0, ratio, 0, 0],
        viewport: viewport,
      };
      page.render(renderContext);

      if (canvasContainer) {
        const oldCanvas = canvasContainer.children[i - 1];
        if (oldCanvas) {
          canvasContainer.replaceChild(canvas, oldCanvas);
        } else {
          canvasContainer?.appendChild(canvas);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-container {
  ::v-deep canvas {
    margin-bottom: 10px;
  }
}
</style>
